import { useTranslations } from "next-intl"
import { useEffect, useState } from "react"
import styles from "./FreeTrialActiveModal.module.css"
import Button, { ButtonSize } from "@/components/UI/Buttons/Button/Button"
import Image_FreeTrial from "@/assets/img/Image_FreeTrial.svg"
import Icon from "@/components/UI/Icon/Icon"
import IconCross from "@/assets/img/Icon_Cross.svg"
import IconButton, { IconButtonKind, IconButtonSize } from "@/components/UI/Buttons/IconButton/IconButton"

interface FreeTrialActiveModalProps extends React.HTMLAttributes<HTMLDivElement> {
  onClose: () => void,
  expirationDate: string
}

export default function FreeTrialActiveModal({ onClose, expirationDate }: FreeTrialActiveModalProps) {
	const t = useTranslations("Modals.FreeTrialActive")
	const [timeLeft, setTimeLeft] = useState("") 	// Countdown state

	useEffect(() => {
		function updateTimeLeft() {
			const expiration = new Date(expirationDate);
			const now = new Date();
			let diff = expiration.getTime() - now.getTime();
			if (diff < 0) diff = 0;
			const hours = Math.floor(diff / (1000 * 60 * 60));
			const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
			const seconds = Math.floor((diff % (1000 * 60)) / 1000);
			setTimeLeft(
				`${hours.toString().padStart(2, '0')}:` +
				`${minutes.toString().padStart(2, '0')}:` +
				`${seconds.toString().padStart(2, '0')}`
			);
		}
		updateTimeLeft();
		const interval = setInterval(updateTimeLeft, 1000);
		return () => clearInterval(interval);
	}, [expirationDate]);

	return (
		<div className={styles.main}>
			<div className={styles.closeBtnWrapper}>
        <IconButton
          icon={IconCross}
          size={IconButtonSize.M}
          kind={IconButtonKind.EMPTY}
          onClick={onClose}
        />
      </div>

			<Icon icon={Image_FreeTrial} className={styles.icon}/>

			<div className={styles.contentWrapper}>
				<h2 className="title2">{t('title')}</h2>

				<div className={styles.expiration}>
					<p className={`bodyTextMedium ${styles.expirationContent}`}>{t('trialExpiresIn')}</p>
					<h3 className="title2">{timeLeft}</h3>
				</div>
				
				<p className="bodyTextLarge">{t('text')}</p>
			</div>

			<div className={styles.buttons}>
				<Button size={ButtonSize.MEDIUM} onClick={onClose}>{t('button')}</Button>
			</div>
		</div>
	)
}